/* eslint-disable react/prop-types */
import React from 'react';
import dayjs from 'dayjs';
import RescheduleConfirmModal from '../RescheduleConfirmModal';
import { Container } from './styled';
import {
  getUniqueGarageProsedDates,
  shouldShowRescheduleSection,
  canFinaliseCaseManagerReviewedProposal,
  canFinaliseGarageProposal,
  canFinaliseCustomerConfirmedProposal,
} from './logic';
import { FRIENDLY_DATE_FORMAT } from '../shared/constants';

const GarageProposedDatesSection = ({ garageInvites }) => {
  const formattedGarageProposedDates = getUniqueGarageProsedDates(garageInvites)
    .map((date) => dayjs(date).format(FRIENDLY_DATE_FORMAT))
    .join(', ');

  return (
    <>
      <b>New date(s) proposed by garage(s):</b> {formattedGarageProposedDates}
    </>
  );
};

const ManuallyFinaliseRescheduleSection = ({ booking }) => (
  <>
    <b>Finalise reschedule manually</b>
    <p>
      Reschedule options sent to customer (see notes). If needed, you can enter the customer’s choice manually
      below.
    </p>
    <RescheduleConfirmModal booking={booking} />
  </>
);

const DateChosenByCustomerSection = ({ booking }) => {
  const { collectionDateTimeLocal } = booking;
  const formattedDate = dayjs(collectionDateTimeLocal).format(FRIENDLY_DATE_FORMAT);
  return (
    <>
      <b>Customer Rescheduled: Please accept an invite from the Garage invitation table</b>
      <p>Date chosen by customer for reschedule: {formattedDate}</p>
    </>
  );
};

const AlertContent = ({ booking }) => {
  const { garageInvites } = booking;

  if (canFinaliseGarageProposal(garageInvites))
    return <GarageProposedDatesSection garageInvites={garageInvites} />;

  if (canFinaliseCaseManagerReviewedProposal(garageInvites))
    return <ManuallyFinaliseRescheduleSection booking={booking} />;

  if (canFinaliseCustomerConfirmedProposal(garageInvites))
    return <DateChosenByCustomerSection booking={booking} />;

  return <b>really nothing</b>;
};

const RescheduleProposalAlert = ({ booking }) => {
  const displayComponent = shouldShowRescheduleSection(booking.garageInvites);
  if (!displayComponent) return null;

  return (
    <Container>
      <img src="/assets/images/reviewing.png" alt="reviewing" />

      <AlertContent booking={booking} />
    </Container>
  );
};

export default RescheduleProposalAlert;
